import { useQuery } from '@tanstack/react-query';

import { gqlClient } from '@/api/graphql-client';
import scheduledEventKeys from '@/api/queries/scheduleEvents/keyFactory';
import { graphql } from '@/gql';

const GET_SCHEDULE_EVENT = graphql(`
  query GetScheduleEvent($id: ID!) {
    scheduledEvent: event(id: $id) {
      id
      publicId
      name
      description
      beginAt
      endAt
      project {
        id
        publicId
      }
      folderEntries {
        ... on FolderEntry {
          __typename
          id
          parentFolderId
          name
          createdAt
          updatedAt
          isDeletable {
            __typename
          }
          isShareable {
            __typename
          }
          isSharedWithCustomer
        }
        ... on DocumentInstanceFolderEntry {
          documentInstance {
            id
            documentHtml
            name
          }
        }
      }

      assignees {
        id
        publicId
        fullName
      }
    }
  }
`);

const useGetScheduledEvent = (id?: number | string) => {
  return useQuery({
    enabled: !!id,
    queryKey: scheduledEventKeys.scheduledEvent(id!),
    queryFn: () => {
      return gqlClient.request(GET_SCHEDULE_EVENT, {
        id: id!.toString(),
      });
    },
  });
};

export default useGetScheduledEvent;
